import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const ProjectList = React.lazy(() => import('@/modules/project/components/list/project-list'))
const ProjectDetailView = React.lazy(() => import('@/modules/project/components/detail/project-detail.component'))
const ProjectEditView = React.lazy(() => import('@/modules/projectV2/project-edit-view'))
const ProjectFormView = React.lazy(() => import('@/modules/transactionV2/components/advancedSettings/project-form-view'))

const projectRoutes = (
  <>
    <Route path='project/*' element={<RedirectToPlural />} />
    <Route path='projects' Component={ProjectList} handle={{ title: 'Projekte', options: { noBackgroundColor: true } }} />

    <Route path='projects/:id' Component={ProjectDetailView} />
    <Route path='projects/:id/:action' Component={ProjectDetailView} />

    <Route path='projects/edit/:id' Component={ProjectFormView} />
    <Route path='projects/new/:offerId?' Component={ProjectEditView} />
    <Route path='projects/new/customer/:customerId' Component={ProjectEditView} />
  </>
)

export default projectRoutes
